import React from "react"
import { getUser } from "../util"
import { Stack, Typography } from "@mui/material"
import { Field } from "formik"
import { FormContainer, NavButtons } from "../../../../Menu/Flow"
import employerFlowStyles from "../../styles"
import { validateEmail } from "../../../../../../helpers/utils"
export default function Contact(props) {
    const { mode, exitUrl, step, formik } = props
    const { errors, touched, handleBlur, setFieldValue } = formik

    const handleEmailBlur = async (e) => {
        const email = e.target.value
        handleBlur(e)
        
        if (validateEmail(email)) {
            const user = await getUser(email)
            if (user) {
                const { firstName, lastName, phone } = user
                setFieldValue("contactFirstName", firstName)
                setFieldValue("contactLastName", lastName)
                setFieldValue("phone", phone)
            }
        }
    }

    return (
        <Stack spacing="30px" height="100%">
            <FormContainer>
                <Typography variant="h2" sx={employerFlowStyles.h2}>Contact</Typography>
                <Typography>
                    Enter your company's primary contact - this name appears in all plan documents.
                </Typography>

                <Stack spacing={2} sx={{ marginTop: "40px" }}>
                    {/* First Name and Last Name Row */}
                    <Stack direction="row" spacing={2}>
                        <Stack flex={1}>
                            <Typography sx={{ marginBottom: "8px" }}>
                                Contact First Name
                            </Typography>
                            <Field name="contactFirstName">
                                {({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        style={{
                                            width: "100%",
                                            padding: "12px",
                                            border: `1px solid ${errors.contactFirstName && touched.contactFirstName ? "#dc2626" : "#ACBEE8"}`,
                                            borderRadius: "8px",
                                            fontSize: "14px"
                                        }}
                                    />
                                )}
                            </Field>
                            {errors.contactFirstName && touched.contactFirstName && (
                                <div className="error-message-fields">{errors.contactFirstName}</div>
                            )}
                        </Stack>

                        <Stack flex={1}>
                            <Typography sx={{ marginBottom: "8px" }}>
                                Contact Last Name
                            </Typography>
                            <Field name="contactLastName">
                                {({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        style={{
                                            width: "100%",
                                            padding: "12px",
                                            border: `1px solid ${errors.contactLastName && touched.contactLastName ? "#dc2626" : "#ACBEE8"}`,
                                            borderRadius: "8px",
                                            fontSize: "14px"
                                        }}
                                    />
                                )}
                            </Field>
                            {errors.contactLastName && touched.contactLastName && (
                                <div className="error-message-fields">{errors.contactLastName}</div>
                            )}
                        </Stack>
                    </Stack>

                    {/* Email and Phone Row */}
                    <Stack direction="row" spacing={2}>
                        <Stack flex={1}>
                            <Typography sx={{ marginTop: "20px", marginBottom: "8px" }}>
                                Contact Email
                            </Typography>
                            <Field name="email">
                                {({ field }) => (
                                    <input
                                        {...field}
                                        type="email"
                                        onBlur={handleEmailBlur}
                                        style={{
                                            width: "100%",
                                            padding: "12px",
                                            border: `1px solid ${errors.email && touched.email ? "#dc2626" : "#ACBEE8"}`,
                                            borderRadius: "8px",
                                            fontSize: "14px"
                                        }}
                                    />
                                )}
                            </Field>
                            {errors.email && touched.email && (
                                <div className="error-message-fields">{errors.email}</div>
                            )}
                        </Stack>

                        <Stack flex={1}>
                            <Typography sx={{ marginTop: "20px", marginBottom: "8px" }}>
                                Contact Phone
                            </Typography>
                            <Field name="phone">
                                {({ field }) => (
                                    <input
                                        {...field}
                                        type="tel"
                                        style={{
                                            width: "100%",
                                            padding: "12px",
                                            border: `1px solid ${errors.phone && touched.phone ? "#dc2626" : "#ACBEE8"}`,
                                            borderRadius: "8px",
                                            fontSize: "14px"
                                        }}
                                    />
                                )}
                            </Field>
                            {errors.phone && touched.phone && (
                                <div className="error-message-fields">{errors.phone}</div>
                            )}
                        </Stack>
                    </Stack>
                </Stack>
            </FormContainer>

            <NavButtons mode={mode} enableSave={true} exitUrl={exitUrl} step={step} />
        </Stack>
    )
}